<template lang="pug">
  #editSubject.container(ref='editSubject')
    .row.justify-content-center
      .col-md-6.col-12
        .card
          .card-header {{name ? name : 'Khối lớp'}}
          .card-body
            //- .alert.alert-danger(v-if="error") {{error}}
            form(action="#", autocomplete="off")
              .form-group.col-md-12(style="margin:0")
                .alert.alert-danger(v-if="error" style="margin:0") {{error}}
              .form-group(:class='errorArray')
                .col-md-12
                  label.control-label.text-md-right(for="title") Tên khối lớp *
                  input#title.form-control(name="title",required=true,autofocus,placeholder="Tên khối lớp",v-model="name")
              .form-group
                .col-md-12
                  label.control-label.text-md-right(for="description") Mô tả
                  input#description.form-control(name="description", placeholder="Mô tả", v-model="content")
              .form-group
                .col-md-12
                  label.control-label.text-md-right(for="type_grade") Loại cấp
                  input#type_grade.form-control(name="type_grade" type="number" v-model="type")
              .form-group
                .col-md-8.offset-md-4
                  button.btn.btn-primary(@click.prevent='submitForm') Lưu
                  button.btn.btn-primary(@click.prevent="$emit('close')") Hủy
</template>

<script>
// import firebase from 'firebase'

export default {
  name: 'grades-form',
  props: {
    id: Number,
    type_grade: Number,
    title: String,
    description: String,
    saveFunction: Function
  },
  data() {
    return {
      error: null,
      errorArray: [],
      name: this.title,
      content: this.description,
      type: this.type_grade
    }
  },
  methods: {
    submitForm() {
      if (this.name !== undefined && this.name !== null) {
        this.saveFunction({ id: this.id, title: this.name, description: this.content, type_grade: this.type })
        this.$nextTick(() => {
          this.$emit('close')
        })
      } else {
        this.error = 'Tên khối lớp là bắt buộc'
        this.errorArray = ['is-empty has-error']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// gradeForm.vue?06bb0410